
import Vue from 'vue'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import DriveCard from './DriveCard.vue'
import { RLoader, PlaceholderWithButton, GoTo } from '@/components'
import { routerPush } from '@/services/routing'
import { getAppRootURL } from '@/config'

export default Vue.extend({
  name: 'Drives',
  head: {
    link: [{ rel: 'canonical', href: `${getAppRootURL()}/drives`, id: 'canonical' }],
  },
  components: {
    DriveCard,
    RLoader,
    PlaceholderWithButton,
    GoTo,
  },
  created() {
    this.bindUserDrives()
  },
  computed: {
    ...mapGetters({
      user: 'user/user',
      profile: 'user/profile',
      hasPaymentMethod: 'user/hasPaymentMethod',
      drives: 'drive/drives',
      canAssign: 'drive/canAssign',
      isDriveBeingCreated: 'drive/isBeingCreated',
    }),
    loading(): boolean {
      return this.drives === null
    },
    title(): string {
      if (!this.hasPaymentMethod) {
        return 'Before you start working'
      }
      if (!this.hasDrive) {
        return 'No resources to show'
      }
      return ''
    },
    message(): string {
      if (!this.hasPaymentMethod || !this.hasDrive) {
        return 'You need to select your Renderro Plan to start working.'
      }
      return ''
    },
    buttonText(): string {
      if (!this.hasPaymentMethod || !this.hasDrive) {
        return 'Select Renderro Plan'
      }
      return ''
    },
    hasDrive(): boolean {
      return this.drives.length > 0
    },
    showSharedLinksLink(): boolean {
      return true
    },
  },
  methods: {
    ...mapActions({
      bindUserDrives: 'drive/bindUserDrives',
      goToDirectory: 'file/goToDirectory',
    }),
    ...mapMutations({
      selectDrive: 'file/selectDrive',
    }),
    handleBrowse(uuid: string): void {
      this.selectDrive({ uuid })
      this.goToDirectory()
    },
    handleSetupClick() {
      if (!this.hasPaymentMethod || !this.hasDrive) {
        routerPush(this.$router, '/setup')
      }
    },
  },
})
